module.exports = "/static/assets/8bc7ca67021e0ae70e918543b309e810.png";